import { QueryParam } from "../../../types/api/generic.type";
import { GetPotentialMatrixDevelopmentCollaboratorsResponse } from "../../../types/api/potentialMatrix.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const PotentialMatrixDevelopmentCollaboratorsService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetPotentialMatrixDevelopmentCollaboratorsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response =
      await httpClient.get<GetPotentialMatrixDevelopmentCollaboratorsResponse>(
        `v1/potential-matrix-development/collaborators?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
};

export default PotentialMatrixDevelopmentCollaboratorsService;
